<template>
    <v-form v-model="valid" ref="form">
    <v-container class="pr-6 mt-4" fluid>
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-text-field label="Description on purchase forms" v-model="nonExcise.buyingDescription" :rules="[fieldRules.maxLength(50)]" :counter="50" outlined dense/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" sm="3" md="2">
          <decimal-number-input label="Reorder point" v-model="nonExcise.reorderPoint" prefix="" suffix="litres" :precision="3" no-minimum
                                hint="Reordering should occur if inventory is at this point"/>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <decimal-number-input label="Default reorder quantity" v-model="nonExcise.reorderQuantity" prefix="" suffix="litres" :precision="3"/>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <decimal-number-input label="Reorder lead time" v-model="nonExcise.reorderDays" prefix="" suffix="days" :precision="0"/>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <v-checkbox label="Business days" v-model="nonExcise.reorderBusinessDays" hide-details class="mt-1"/>
        </v-col>
      </v-row>
      <v-row dense v-if="vendors.length>0">
        <v-col cols="12" sm="6" md="4">
          <v-autocomplete outlined dense hide-details clearable label="Preferred supplier" v-model="nonExcise.preferredVendorId" :items="vendors" item-value="id" item-text="name"/>
        </v-col>
      </v-row>

      <v-row class="mt-4">
        <v-col cols="12" md="10" lg="8">
          <supplier-costing :vendors="nonExcise.vendors" :allVendors="vendors" :taxes="taxes" :default-sku="nonExcise.sku" units="Litres"/>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import SupplierCosting from '@/components/SupplierCosting'

export default {
  name: 'AlcoholNonExcisesEditBuying',
  components: {SupplierCosting},
  props: {
    nonExcise: {type:Object, required:true},
    taxes: {type:Array, required:true},
  },
  data() {
    return {
      valid: true,
      vendors: []
    }
  },
  computed: {
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    }
  },
  async created() {
    if (this.$store.getters.company.permissions.includes('buying'))
      this.$lazyListLoad(this.vendors, 'vendors2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);
  }
}
</script>